import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  NationalityManagerCreateActions,
  UiActions
} from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestNationalityManagerCreate } from 'src/app/shared/interfaces';
import { RedirectService } from 'src/app/services/redirect.service';
import { StepsClientTypes, StepsNotClientTypes } from '../../../shared/enums';
import { countries } from '../data/countries';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { DataClientService } from 'src/app/services/data-client.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nationality-joint',
  templateUrl: './nationality-joint.component.html',
  styleUrls: ['../../../global.scss', './nationality-joint.component.scss']
})
export class NationalityJointComponent implements OnInit, OnDestroy {
  send = false;
  jointIsClient: boolean;
  countries: any = countries;
  countriesNationality: any;
  formData: FormGroup;
  dataService: DataClientService | DataNotClientService;
  privateMode = false;
  staticAssetsUrl = environment.staticScripts.staticAssets;

  nationalityManager$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.nationalityManagerCreate)
  );

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    private dataClientService: DataClientService,
    public loadingService: LoadingService,
    public sessionService: SessionService,
    private _fb: FormBuilder,
    private redirectService: RedirectService
  ) {
    this.setService();
    this.setForm();
  }

  nationalityManagerSuscription = this.nationalityManager$.subscribe(({ response, error }) => {
    // error case
    if (error != null) {
      this.redirectService.setRedirect(StepsNotClientTypes.STEP_PUBLIC_LANDING);
      this.store.dispatch(NationalityManagerCreateActions.cleanState());
      const step = this.privateMode ? StepsClientTypes.STEP_SERVICE_ERROR : StepsNotClientTypes.STEP_SERVICE_ERROR;
      this.store.dispatch(UiActions.Navigate({ step }));
    }

    if (response != null && (response.client.operationState.code === '00' && response.joint.operationState.code === '00')) {
      this.store.dispatch(NationalityManagerCreateActions.cleanState());
      this.loadingService.loading = false;
      if (this.send) {
        this.store.dispatch(UiActions.Navigate({step: this.navigation()}));
      }
    }
  });

  ngOnInit() {
    this.store.select('stepsNoClient').subscribe();
  }

  ngOnDestroy() {
    this.nationalityManagerSuscription.unsubscribe();
  }

  setService() {
    if (this.dataNotClientService.getJointIsClient() && this.dataNotClientService.getIdentificationTypeJoint() !== '4') {
      this.jointIsClient = true;
    }
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    const googleAnalytics = {
      is_joint_account: this.dataService.isIsJointAccount(),
      job_information: {
        workActivityType: this.dataService.getWorkActivityTypeJoint() ? this.dataService.getWorkActivityTypeJoint() : 'No informado',
        dateEntryWork: this.dataService.getDateEntryWorkJoint() ? this.dataService.getDateEntryWorkJoint() : 'No informado',
        companyName: this.dataService.getCompanyNameJoint() ? this.dataService.getCompanyNameJoint() : 'No informado',
        rucCompany: this.dataService.getRucCompanyJoint() ? this.dataService.getRucCompanyJoint() : 'No informado',
        profession: this.dataService.getProfessionJoint() ? this.dataService.getProfessionJoint() : 'No informado'
      }
    };
    this.store.dispatch(TagPage({text: 'nationality-information-joint', extras: googleAnalytics}));
  }

  continue() {
    // Data for all screens
    this.dataService.setNationalityJoint(this.formData.controls['nationality'].value);
    this.dataNotClientService.setCountryBirthJoint(this.formData.controls['countryBirth'].value);
    this.dataService.setTaxResidenceJoint(this.formData.controls['taxResidence'].value);
    this.dataService.setResidenceCountryJoint(this.formData.controls['residenceCountry'].value);
    if (this.privateMode) {
      this.dataService.setJointIsForeign(this.dataService.jointIsForeign());
    }

    this.loadingService.loading = true;

    const request: RequestNationalityManagerCreate = {
      client: {
        nationality: this.dataService.getNationality(),
        residenceCountry: this.dataService.getResidenceCountry(),
        taxResidence: this.dataService.getTaxResidence()
      },
      joint: {
        nationality: this.dataService.getNationalityJoint(),
        residenceCountry: this.dataService.getResidenceCountryJoint(),
        taxResidence: this.dataService.getTaxResidenceJoint()
      }
    };

    if (!this.privateMode) {
      request.client.countryBirth = this.dataNotClientService.getCountryBirth();
      request.joint.countryBirth = this.dataNotClientService.getCountryBirthJoint();
    }
    this.send = true;
    this.store.dispatch(NationalityManagerCreateActions.getNationalityManagerCreate({ request }));
  }

  navigation(): StepsClientTypes | StepsNotClientTypes {
    if (this.privateMode) {
      if (this.dataClientService.getAccountType() === 'Ahorro') {
        return StepsClientTypes.STEP_INFORMATION_PEP;
      } else {
        return StepsClientTypes.STEP_INFORMATION_LABOR_CLIENT;
      }
    } else {
      return StepsNotClientTypes.STEP_INFORMATION_PEP;
    }
  }

  setForm() {
    this.preloadForm();

    this.countriesNationality = countries.map((country) => country);
    if (this.dataService.jointIsForeign()) {
      this.countriesNationality.shift();
    }
  }

  preloadForm() {
    const peru = this.countries.find((country) => country.iso = '4028');
    if (this.dataService.jointIsForeign()) {
      return this.formData = this._fb.group({
        countryBirth: [null],
        nationality: [ null, Validators.required],
        residenceCountry: [ null, Validators.required],
        taxResidence: [ null, Validators.required]
      });
    } else {
      this.formData = this._fb.group({
        countryBirth: [null],
        nationality: [ peru.iso, Validators.required],
        residenceCountry: [ peru.iso, Validators.required],
        taxResidence: [ peru.iso, Validators.required]
      });

      if (!this.jointIsClient) {
        this.formData.controls.countryBirth.setValue(peru.iso);
        this.formData.controls.countryBirth.setValidators([Validators.required]);
        this.formData.controls.countryBirth.updateValueAndValidity();
      }
      return this.formData;
    }
  }
}
